import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/shared/Button';
import ResendConfirmationButton from '@/components/shared/ResendConfirmationButton/ResendConfirmationButton';
import './MultiStepSignupStep4.scss';

const baseClass = 'MultiStepSignupStep4';

interface Props {
  email: string;
}

const MultiStepSignupStep4: React.FC<Props> = ({ email }) => {
  const navigate = useNavigate();

  return (
    <div className={baseClass}>
      <h2 className={`${baseClass}__title`}>Thank you for registering.</h2>
      <p className={`${baseClass}__text`}>
        Your user account has been successfully created. To activate your account, please click the link in the confirmation email sent to you. If you do not receive the email within 30 minutes, please check your spam folder or <a href="mailto:support@propsavvy.ca">contact support</a>.
      </p>
      <div className={`${baseClass}__actions`}>
        <Button onClick={() => navigate('/login')}>
          Proceed to Login
        </Button>
        <ResendConfirmationButton email={email} />
      </div>
    </div>
  );
};

export default MultiStepSignupStep4;
